import algosdk from "algosdk";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "../context/WalletContext";
import "../styles/referido.css";
import "../styles/general.css";

interface ReferidoProps {
  algodClient: algosdk.Algodv2;
  setMessage: (msg: string) => void;
  account: string;
  username: string;
  algoBalance: number;
  umqBalance: number;
  logout: () => void;
}

const Referido: React.FC<ReferidoProps> = ({ algodClient, setMessage }) => {
  const navigate = useNavigate();
  const { account } = useWallet();

  const appId = 748945594;
  const ASA_ID = 748884896;

  const [isOptedIn, setIsOptedIn] = useState(false);
  const [hasClaimed, setHasClaimed] = useState(false);
  const [txId, setTxId] = useState<string | null>(null);
  const [userEmail, setUserEmail] = useState("");
  const [invited, setInvited] = useState("");

  const SERVER_ENDPOINT = "/api/sendpulse";

  const CLIENT_ID = process.env.CLIENT_ID;
  const CLIENT_SECRET = process.env.CLIENT_SECRET;

  const readAppLocalState = useCallback(async () => {
    if (!account?.addr) return;

    try {
      const accountInfo = await algodClient.accountApplicationInformation(account.addr, appId).do();
      const localState = accountInfo["app-local-state"]?.["key-value"] || [];

      setIsOptedIn(!!accountInfo["app-local-state"]);

      const claimed = localState.some((state: any) => {
        const key = Buffer.from(state.key, "base64").toString();
        return key === "has_claimed" && state.value.uint > 0;
      });

      setHasClaimed(claimed);
    } catch (error) {
      console.error("Error leyendo estado local:", error);
    }
  }, [account, algodClient, appId]);

  async function waitForConfirmation(algodClient: algosdk.Algodv2, txId: string) {
  const status = await algodClient.status().do();
  let lastRound = status["last-round"];

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const pendingInfo = await algodClient.pendingTransactionInformation(txId).do();
    if (pendingInfo["confirmed-round"] && pendingInfo["confirmed-round"] > 0) {
      console.log("✅ Confirmado en el bloque:", pendingInfo["confirmed-round"]);
      break;
    }
    lastRound++;
    await algodClient.statusAfterBlock(lastRound).do();
  }
}

  const optInToApp = useCallback(async () => {
    try {
      if (!account?.sk || !account?.addr) throw new Error("Cuenta MoxWallet no conectada.");

      const suggestedParams = await algodClient.getTransactionParams().do();
      const optInTxn = algosdk.makeApplicationOptInTxn(account.addr, suggestedParams, appId);

      const signedTxn = optInTxn.signTxn(account.sk);
      const { txId } = await algodClient.sendRawTransaction(signedTxn).do();

      setMessage(`Opt-in App exitoso. TxID: ${txId}`);
      await waitForConfirmation(algodClient, txId);
      await readAppLocalState();
    } catch (error) {
      console.error("Error en optInToApp:", error);
      setMessage("Error durante el Opt-in a la App.");
    }
  }, [account, algodClient, appId, setMessage, readAppLocalState]);

  const claimASA = useCallback(async () => {
  if (hasClaimed) {
    setMessage("Ya reclamaste tus tokens.");
    return;
  }

  try {
    if (!account?.sk || !account?.addr) throw new Error("Cuenta MoxWallet no conectada.");

    const suggestedParams = await algodClient.getTransactionParams().do();
    const claimTxn = algosdk.makeApplicationNoOpTxnFromObject({
      from: account.addr,
      appIndex: appId,
      appArgs: [new Uint8Array(Buffer.from("claim_airdrop"))],
      foreignAssets: [ASA_ID],
      suggestedParams,
    });

    const signedTxn = claimTxn.signTxn(account.sk);
    const { txId } = await algodClient.sendRawTransaction(signedTxn).do();

    setTxId(txId);
    setMessage(`Tokens reclamados. TxID: ${txId}`);
    await waitForConfirmation(algodClient, txId);
    await readAppLocalState();
  } catch (error) {
    console.error("Error en claimASA:", error);
    setMessage("Error al reclamar el Airdrop.");
  }
}, [account, algodClient, appId, ASA_ID, setMessage, hasClaimed, readAppLocalState]);

  const sendReferralEmail = async () => {
    const payload = {
        action: "send_referral", 
        email: userEmail,
        phone: "",
        referido: account?.addr,
        invited: invited,
    };

    try {
        const response = await fetch(SERVER_ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "Error desconocido al enviar el formulario.");
        }

        setMessage("Energia activada");
    } catch (error) {
        console.error("Error al enviar el correo:", error);
        setMessage(`Error enviando el correo: ${error.message}`);
    }
};

  useEffect(() => {
    if (txId) localStorage.setItem("txId", txId);
  }, [txId]);

  useEffect(() => {
    const savedTxId = localStorage.getItem("txId");
    if (!txId && savedTxId) setTxId(savedTxId);
  }, [txId]);

  useEffect(() => {
    readAppLocalState();
  }, [readAppLocalState]);

  if (!account) return <div><p>
          Conecta tu MoxWallet para continuar.{" "}
          <span
            style={{ color: "#1E90FF", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => navigate("/home")}
          >
            Volver a Home
          </span>
        </p></div>;

  return (
    <div className="modal-container">
      <h1>Reclama tus 500 UMQ</h1>
      {!isOptedIn ? (
        <button className="button-primary" onClick={optInToApp}>Activar Regalo</button>
      ) : !hasClaimed ? (
        <div>
          <p>Reclama tus UMQ.</p>
          <button className="button-primary" onClick={claimASA}>Reclamar UMQ</button>
        </div>
      ) : (
        <div>
          <h4 className="codigo-referido">
            {account.addr ? (
              <>
              Felicidades. Tu código referido es {""}
              <span className="referral-message">{account.addr.slice(0, 8)}...{account.addr.slice(-4)}</span>
              </>
      ) : (
            "Ya has reclamado tus UMQ."
      )}
          </h4>
          <p>Activa tu energia del reconocimiento</p>
          <p>Si eres invitado ingresa el codigo y entrega energia de reconocimiento. TU forma de dar gracias por la invitacion</p>
          <div className="referral-container">
            <input
              type="email"
              placeholder="Ingresa tu correo"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              className="email-input"
            />
            <input
              type="invited"
              placeholder="Tu codigo como invitado"
              value={invited}
              onChange={(e) => setInvited(e.target.value)}
              className="email-input"
            />            
          </div>
          <button className="button-secondary" onClick={sendReferralEmail}>
              Activar energia
            </button>
        </div>
      )}
      <button className="button-exit" onClick={() => navigate("/home")}>
        Volver
      </button>
    </div>
  );
}
  
  export default Referido;